import { NgModule } from '@angular/core';
import { M2Df2ScaffoldComponent } from './m2-df2-scaffold.component';



@NgModule({
  declarations: [M2Df2ScaffoldComponent],
  imports: [
  ],
  exports: [M2Df2ScaffoldComponent]
})
export class M2Df2ScaffoldModule { }
